import { getAuthToken } from '@/utils/local-storage'
import HttpRequest from './http_request'

export default class ProductProvider extends HttpRequest {
  getProducts (page, limit, search, warehouse) {
    this.setHeader(getAuthToken())
    return this.get(`/products?page=${page}&limit=${limit}&search=${search}&warehouse=${warehouse}`)
  }
}
